import httpClient from "./httpClient";

/** @returns {Promise<Array>} */
export const getAllBlogPosts = async () => {
  const { data } = await httpClient.get("/blog/all");
  return data.posts || [];
};

/** @returns {Promise<object|null>} */
export const getBlogPostBySlug = async (slug) => {
  const { data } = await httpClient.get(
    `/blog/slug/${encodeURIComponent(slug)}`
  );
  return data.post || null;
};
